import { Icon, IconButton, Tooltip } from "@mui/material";
import { DefaultCell } from "../../../Component/Common/Components/DataTable/DefaultCell";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { DigitalContentSectionItem } from "../../../Component/Model/Dto/Academy";
import { TableDateHelper } from "../../../Component/Model/helpers";
import { TableColumn } from "../../../Component/Model/Table/Table";

interface DigitalContentSectionRow {
    id:                  number;
    description:         string;
    createdDate:         string | undefined;
    url:                 string;
}

interface DigitalContentSectionTable {
    columns: Array<TableColumn>;
    rows: Array<DigitalContentSectionRow>;
}

const getActionButton = (url: string) =>{
    return(
        <IconButton onClick={() => window.open(url)} >
        <Tooltip title={"Go To Content"}>
            <MDTypography variant="caption" color="primary" lineHeight={1} sx={{ cursor: "pointer", mx: 0 }}>
            <Icon color="inherit" fontSize="small">launch</Icon>
            </MDTypography>
        </Tooltip>
        </IconButton>
    )
}

export function  DigitalContentSectionTableMapper(dataObject: DigitalContentSectionItem.DtoIn[]): DigitalContentSectionTable | undefined {
    const columns = [
        { Header: 'Description', accessor: 'description', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={"300px"}/>, disableSortBy: true},
        { Header: 'Date Added', accessor: 'createdDate', Cell: ({ value }: any) => <DefaultCell value={value}/>, disableSortBy: true },
        { Header: 'Actions', accessor: 'url', Cell: ({ value }: any) => getActionButton(value), disableSortBy: true},
    ];

    if (dataObject !== undefined && dataObject.length > 0){
        const rows = dataObject.map((item:DigitalContentSectionItem.DtoIn) => ({
            id: item.id,
            description: item.description,
            createdDate: TableDateHelper(item.createdDate) !== undefined ? TableDateHelper(item.createdDate) : "Undefined",
            url: item.url
        }));

        return { columns: columns, rows: rows };
        
    }else {
        return { columns: columns, rows: [] };
    }
}